import { render, staticRenderFns } from "./DialogIdle.vue?vue&type=template&id=5f5aaa22"
import script from "./DialogIdle.vue?vue&type=script&lang=js"
export * from "./DialogIdle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports